import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyAuSGeiif6uYLwKI_z-JuZJw3CprotQqWE",
  authDomain: "responsive-dashboard-with-news.firebaseapp.com",
  projectId: "responsive-dashboard-with-news",
  storageBucket: "responsive-dashboard-with-news.firebasestorage.app",
  messagingSenderId: "574737566819",
  appId: "1:574737566819:web:5ce5e85e1ccb1295d0fc56",
  measurementId: "G-GVFYPPNZEZ"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
